import React, { useRef, useState, useEffect } from 'react';
import { Container, Row, Col, Button, Carousel, Spinner } from 'react-bootstrap';
import { FaWhatsapp, FaCheckCircle, FaPlay, FaPause, FaStar, FaGoogle, FaCheck } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import './Hormigon.css';

// --------------------------------------------------------
// 1. DATOS ESTÁTICOS 
// --------------------------------------------------------
const mainPhone = "542215739000";

const benefits = [
  { 
    src: '/elegirnoslaboratorio.png', 
    title: 'LABORATORIO EN OBRA', 
    description: 'Controles de calidad realizados por profesionales experimentados con equipamiento especializado.' 
  },
  { 
    src: '/elegirnosticket.png', 
    title: 'TICKET DE PESADA', 
    description: 'Comprobante con el peso exacto de cada carga, garantizando transparencia.' 
  },
  { 
    src: '/elegirnoscargaprecintada.png', 
    title: 'CARGA PRECINTADA', 
    description: 'Sistema de seguridad que evita adulteraciones durante el transporte.' 
  },
  { 
    src: '/elegirnosseguimiento.png', 
    title: 'RASTREO SATELITAL', 
    description: 'Monitoreo en tiempo real desde planta hasta obra para máxima trazabilidad.' 
  }
];

const suppliers = [
  { src: '/logolomanegra.png', alt: 'Loma Negra' },
  { src: '/LOGOSIKA.png', alt: 'Sika' },
  { src: '/logoacindarofi.png', alt: 'Red Acindar' },
  { src: '/logodafre.jpg', alt: 'Dafre' },
  { src: '/logo varsovia.jpg', alt: 'Grupo Varsovia' },
  { src: '/LOGOTECMA.PNG', alt: 'Tecma' },
  { src: '/logoeleprint.png', alt: 'Eleprint' },
  { src: '/logogoldir.png', alt: 'Goldir' },
  { src: '/dycasalogo.jpg', alt: 'Ieb Construcciones' },
  { src: '/logoaubasa.png', alt: 'Aubasa' },
  { src: '/logopfisterer.png', alt: 'Pfisterer' },
  { src: '/logoweber.png', alt: 'Weber' },
  { src: '/logofanelli.png', alt: 'Fanelli' },
  { src: '/logoctibor.png', alt: 'Ctibor' }
];

const hormigonTypes = [
  { title: 'TRADICIONALES', text: 'Desde H8 hasta H47 - Resistencia comprobada en laboratorio' },
  { title: 'BOMBEABLES', text: 'H17 a H38 - Formulaciones especiales para bombeo continuo' },
  { title: 'GUNITADOS', text: 'H21 a H38 - Para proyección con equipo especializado' },
  { title: 'RDC', text: 'RDC 100 a 300 - Hormigones de rápido endurecimiento' },
  { title: 'ESPECIALES', text: 'Livianos, vistos, hidrófugos, con fibra y formulaciones a medida' }
];

const stats = [
  { value: "+40", label: "Años de experiencia" },
  { value: "+3000", label: "Proyectos completados" },
  { value: "100%", label: "Garantía cumplida" },
  { value: "25%", label: "Ahorro promedio" }
];

const pumpingEquipment = [
  { src: '/bombaarrastre.png', alt: 'Bomba de arrastre' },
  { src: '/bombapluma.png', alt: 'Bomba pluma' }
];

// Reseñas añadidas para mantener coherencia
const testimonios = [
  { 
    text: "Excelente experiencia. Muy organizado, con seguimiento GPS del trayecto del camión, y el conductor, súper amable y muy colaborativo para facilitar la descarga. Recomiendo!", 
    author: "Sebastian Leis", project: "Cliente Particular", rating: 5
  },
  { 
    text: "Los mejores! Llené la platea y 3 losas de hormigón de ellos, todo 10 puntos! Se destaca la atención, los productos y el servicio de entrega!", 
    author: "Pablo Laurito", project: "Casa Particular", rating: 5
  },
  { 
    text: "Super puntuales y están siempre al contacto con vos! Ya homigonamos unas 6 veces y siempre llegaron siempre horario, un lujo!", 
    author: "Ricardo Ramos", project: "Cliente Recurrente", rating: 5
  },
  { 
    text: "Excelente atención y logística. Fueron puntuales y organizados. Salió perfecto el trabajo, volveremos a contratarlos seguramente.", 
    author: "Construcciones La Plata", project: "Empresa Constructora", rating: 5
  },
  { 
    text: "Un poco ajustado el cálculo del hormigón que llevaba. Y no alcanzo. Pero lo solucionaron con una rapidez increíble. Muy recomendable!! Calidad, cordialidad.", 
    author: "patri desvoignes", project: "Cliente Particular", rating: 5
  },
  { 
    text: "Excelente servicio de parte de todo el equipo de Darom, desde la recepción del pedido hasta su finalización. El equipo de bombeo muy amable.", 
    author: "Daniel Bobadilla", project: "Cliente Particular", rating: 5
  }
];

// --------------------------------------------------------
// 2. SUB-COMPONENTES PUROS
// --------------------------------------------------------

const ContactButton = ({ text = "CONTACTAR ASESOR", variant = "danger", size = "lg", className = "", center = false }) => {
  const btn = (
    <Button 
      href={`https://wa.me/${mainPhone}?text=${encodeURIComponent("Hola Darom SA, vi su página web y me interesa solicitar cotización de Hormigón Elaborado")}`}
      target="_blank"
      rel="noopener noreferrer"
      className={`hormigon-cta-button fw-bold shadow-sm ${className}`}
      variant={variant}
      size={size}
    >
      <FaWhatsapp className="me-2" size={20} /> {text}
    </Button>
  );

  return center ? <div className="text-center my-3">{btn}</div> : btn;
};

// Pastilla de Google Maps (Se le removió el div contenedor global para ahorrar espacio vertical)
const GoogleRatingBadge = ({ className = "" }) => (
  <a 
    href="#reviews" 
    className={`d-inline-flex align-items-center text-decoration-none py-2 px-4 shadow-sm bg-white rounded-pill google-rating-badge ${className}`} 
    style={{ transition: 'transform 0.2s', whiteSpace: 'nowrap' }}
    onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
    onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
  >
    <FaGoogle className="text-danger me-2" size={20} />
    <div className="d-flex align-items-center mx-2 border-end border-secondary border-opacity-25 pe-3">
      <span className="fw-bold fs-5 me-1" style={{ color: '#212529' }}>4.7</span>
      <FaStar className="text-warning" size={18} />
    </div>
    <span className="small ms-2 fw-bold" style={{ color: '#495057' }}>50+ Reseñas Verificadas</span>
  </a>
);

const QualityBadges = () => (
  <div className="loma-negra-badge">
    <p className="badge-label">CALIDAD CIRSOC Y RESPALDO</p>
    <div className="d-flex align-items-center justify-content-center gap-3">
      <img src="/logolomanegra.png" alt="Loma Negra Partner" loading="lazy" style={{ height: '40px', objectFit: 'contain' }} />
      <div className="vr text-white opacity-50" style={{ minHeight: '30px' }}></div>
      <img src="/CADHE-Logo.png" alt="CADHE Partner" loading="lazy" style={{ height: '40px', objectFit: 'contain' }} />
    </div>
  </div>
);

const BenefitCard = ({ benefit, index, isActive, onHover }) => (
  <div 
    className={`hormigon-benefit-card h-100 ${isActive ? 'active' : ''}`}
    onMouseEnter={() => onHover(index)}
    onTouchStart={() => onHover(index)}
  >
    <div className="hormigon-benefit-logo-container">
      <img src={benefit.src} alt={benefit.title} className="hormigon-benefit-img" loading="lazy" />
    </div>
    <h3 className="hormigon-benefit-title">{benefit.title}</h3>
    <p className="hormigon-benefit-text">{benefit.description}</p>
  </div>
);

const HormigonTypeCard = ({ type }) => (
  <div className="hormigon-type-card p-3 p-md-4 text-center">
    <h4 className="fw-bold hormigon-text-red mb-2 mb-md-3">{type.title}</h4>
    <p className="text-dark mb-0">{type.text}</p>
  </div>
);

const renderCarouselItems = (items, itemsPerSlide, renderItem) => {
  const slides = [];
  for (let i = 0; i < items.length; i += itemsPerSlide) {
    slides.push(
      <Carousel.Item key={i}>
        <Row className="justify-content-center">
          {items.slice(i, i + itemsPerSlide).map((item, idx) => (
            <Col key={idx} md={12 / itemsPerSlide} className="mb-3">
              {renderItem(item, idx)}
            </Col>
          ))}
        </Row>
      </Carousel.Item>
    );
  }
  return slides;
};

// --------------------------------------------------------
// 3. COMPONENTE PRINCIPAL
// --------------------------------------------------------
function Hormigon() {
  const videoRef = useRef(null);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [activeBenefitIndex, setActiveBenefitIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleVideoPlayback = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play().catch(e => console.log("Play failed:", e));
    } else {
      video.pause();
    }
  };

  const handleVideoLoadedData = () => {
    setIsVideoLoaded(true);
    if (window.innerWidth > 768 && videoRef.current) {
      videoRef.current.play().catch(e => console.log("Auto-play prevented:", e));
    }
  };

  return (
    <Container fluid className="px-0 hormigon-container">
      <Helmet>
        <title>Hormigón Elaborado de Alta Calidad | Darom SA</title>
        <meta name="description" content="Hormigón elaborado con garantía de calidad CIRSOC 200/2024, servicio de bombeo y seguimiento satelital. ¡Solicita tu cotización hoy mismo!" />
        <meta name="keywords" content="hormigón elaborado, bombeo hormigón, construcción, Darom SA, hormigón premoldeado, CIRSOC 200/2024" />
        <link rel="canonical" href="https://daromsa.com.ar/services/hormigon" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Hormigón Elaborado y Bombeo",
            "provider": {
              "@type": "Organization",
              "name": "Darom SA",
              "url": "https://daromsa.com.ar"
            },
            "description": "Servicio profesional de hormigón elaborado con control de calidad CIRSOC 200/2024 y servicio de bombeo",
            "serviceType": "Construction",
            "areaServed": "Buenos Aires - Zona Sur"
          })}
        </script>
      </Helmet>

      {/* HERO SECTION */}
      <section className="hormigon-hero-section position-relative">
        <div className="video-container">
          <video 
            ref={videoRef}
            className="hormigon-hero-video"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            onLoadedData={handleVideoLoadedData}
            onPlay={() => setIsVideoPlaying(true)}
            onPause={() => setIsVideoPlaying(false)}
          >
            <source src="/IMG-20241112132439373.mp4" type="video/mp4" />
            Tu navegador no soporta videos HTML5.
          </video>
          
          <div className="video-overlay" />
          
          <button 
            className="video-control-btn"
            onClick={toggleVideoPlayback}
            aria-label={isVideoPlaying ? "Pausar video" : "Reproducir video"}
          >
            {isVideoPlaying ? <FaPause /> : <FaPlay />}
          </button>

          {!isVideoLoaded && (
            <div className="video-loading-spinner">
              <Spinner animation="border" variant="light" />
            </div>
          )}
        </div>
        
        <div className="hormigon-hero-overlay d-flex align-items-center justify-content-center">
          <Container>
            <Row className="justify-content-center">
              <Col xs={12} lg={10} className="text-center">
                {/* NOTA: Márgenes compactados (mb-3 y mb-4 en lugar de mb-4 y mb-5) para evitar cortes en pantallas pequeñas */}
                <div className="hormigon-hero-content-wrapper">
                  <h1 className="hormigon-hero-title display-3 fw-bold mb-3">
                    <span className="d-block hero-title-line">POTENCIÁ TUS</span> 
                    <span className="d-block hero-title-line">PROYECTOS CON</span> 
                    <span className="d-block text-red hero-title-line">NUESTRO HORMIGÓN</span>
                  </h1>
                  
                  <p className="hormigon-hero-subtitle lead mb-3">
                    <strong className="text-red">CONFIANZA, VERSATILIDAD Y GARANTÍA</strong>
                  </p>
                  
                  <div className="hormigon-benefits-grid mb-4">
                    {['Producción bajo normas CIRSOC 200/2024', 'Bombeo profesional con equipos modernos', 'Control de calidad en tiempo real', 'Seguimiento satelital de cada entrega'].map((benefit, idx) => (
                      <div key={idx} className="benefit-item">
                        <FaCheckCircle className="hormigon-check-icon text-red" />
                        <span className="text-white">{benefit}</span>
                      </div>
                    ))}
                  </div>
                  
                  <p className="hormigon-hero-discount h6 mb-3">
                    <strong className="text-white">¡Comparte tu lista o presupuesto con nosotros!</strong>
                    <br />
                    <span className="fw-normal text-white">Te ofrecemos los mejores precios y condiciones.</span>
                  </p>
                  
                  <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3 mb-3">
                    <ContactButton text="SOLICITAR PRESUPUESTO" variant="danger" />
                    <Button 
                      variant="outline-light" 
                      size="lg"
                      href="#tipos-hormigon"
                      className="hormigon-cta-button outline-light shadow-sm fw-bold"
                    >
                      VER TIPOS DE HORMIGÓN
                    </Button>
                  </div>

                  {/* Eliminamos d-flex flex-column para respetar la estructura CSS original y ahorrar alto */}
                  <div className="hero-badges-container">
                    <GoogleRatingBadge className="mb-2" />
                    <QualityBadges />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      {/* TYPES SECTION */}
      <section id="tipos-hormigon" className="hormigon-types-section py-5">
        <Container>
          <h2 className="hormigon-section-title text-center mb-5">
            TIPOS DE <span className="hormigon-text-red">HORMIGÓN</span>
          </h2>
          
          <Carousel indicators={true} interval={4000} touch={true} pause="hover" variant="dark">
            {renderCarouselItems(hormigonTypes, 2, (type, idx) => (
              <HormigonTypeCard key={idx} type={type} />
            ))}
          </Carousel>

          <div className="text-center mt-4">
            <ContactButton text="CONSULTAR POR RESISTENCIAS ESPECIALES" size="md" center={true} />
          </div>
        </Container>
      </section>

      {/* STATS SECTION */}
      <section className="hormigon-stats-section py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="pe-lg-5 mb-4 mb-lg-0">
              <h2 className="fw-bold mb-4 text-white">MÁS DE <span className="text-red">3.000.000 m²</span> CONSTRUIDOS</h2>
              <p className="mb-4 fs-5 text-white">Hemos desarrollado un servicio que integra todas las soluciones para tu obra:</p>
              <div className="hormigon-stats-features-grid mb-4">
                {['Control de calidad en tiempo real', 'Materiales con certificación CIRSOC 200/2024', 'Responsabilidad total garantizada', 'Asesoramiento técnico especializado'].map((feature, idx) => (
                  <div key={idx} className="hormigon-stats-feature-item">
                    <FaCheckCircle className="hormigon-stats-check-icon text-red" />
                    <span className="hormigon-stats-feature-text">{feature}</span>
                  </div>
                ))}
              </div>
              <ContactButton text="CONOCE NUESTRO MÉTODO" center={true} />
            </Col>
            <Col lg={6}>
              <Row className="g-3">
                {stats.map((stat, idx) => (
                  <Col md={6} key={idx}>
                    <div className="hormigon-stats-card">
                      <h3 className="hormigon-stats-value">{stat.value}</h3>
                      <p className="hormigon-stats-label">{stat.label}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      {/* BENEFITS SECTION */}
      <section className="hormigon-benefits-section py-5">
        <Container>
          <h2 className="hormigon-section-title text-center mb-5">
            BENEFICIOS <span className="hormigon-text-red">QUE NOS DIFERENCIAN</span>
          </h2>
          <Row>
            {benefits.map((benefit, index) => (
              <Col lg={3} md={6} key={index} className="mb-4">
                <BenefitCard 
                  benefit={benefit}
                  index={index}
                  isActive={activeBenefitIndex === index}
                  onHover={setActiveBenefitIndex}
                />
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* PUMPING SECTION */}
      <section className="hormigon-pumping-section py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="order-lg-2 ps-lg-5">
              <h2 className="hormigon-section-title mb-4">
                SERVICIO DE <span className="hormigon-text-red">BOMBEO</span> PROFESIONAL
              </h2>
              <p className="hormigon-section-subtitle mb-4 text-dark">Soluciones completas para colocación de hormigón:</p>
              <div className="hormigon-features-grid mb-4">
                {['Bombas estacionarias CIFA SP 750 (50-100 m³/h)', 'Bombas pluma SX36/32 (hasta 130 m³/h)', 'Operadores certificados con amplia experiencia', 'Asesoramiento técnico sin cargo'].map((feature, idx) => (
                  <div key={idx} className="feature-item">
                    <FaCheckCircle className="hormigon-check-icon text-red" />
                    <span className="text-dark">{feature}</span>
                  </div>
                ))}
              </div>
              <ContactButton variant="danger" text="SOLICITAR COTIZACIÓN DE BOMBEO" center={true} />
            </Col>
            <Col lg={6} className="order-lg-1">
              <Carousel indicators={true} interval={3500} variant="dark">
                {pumpingEquipment.map((equipment, idx) => (
                  <Carousel.Item key={idx}>
                    <div className="pumping-image-container">
                      <img src={equipment.src} alt={equipment.alt} className="hormigon-pumping-img" loading="lazy" />
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </Col>
          </Row>
        </Container>
      </section>

      {/* TESTIMONIALS SECTION */}
      <section id="reviews" className="testimonials-section py-5 bg-white border-top">
        <Container>
          <div className="text-center mb-5">
            <h2 className="hormigon-section-title display-6 fw-bold mb-3">
              CONFÍAN EN <span className="hormigon-text-red">NOSOTROS</span>
            </h2>
            <div className="d-flex justify-content-center">
              {/* Esta pastilla está dentro de un flex justify-content-center para que quede bien alineada al centro */}
              <div className="d-inline-flex align-items-center py-2 px-4 shadow-sm bg-light rounded-pill border">
                <FaGoogle className="text-danger me-2" size={20} />
                <div className="d-flex align-items-center mx-2 border-end border-secondary border-opacity-25 pe-3">
                  <span className="rating-value text-dark fw-bold fs-5 me-1">4.7</span>
                  <FaStar className="text-warning" size={18} />
                </div>
                <span className="text-muted small ms-2 fw-semibold">50+ Reseñas Verificadas</span>
              </div>
            </div>
          </div>
          <Row>
            <Col lg={8} className="mx-auto">
              <Carousel indicators={true} interval={6000} pause="hover" variant="dark" className="pb-5">
                {testimonios.map((testimonio, index) => (
                  <Carousel.Item key={index}>
                    <div className="testimonial-card text-center p-4 p-md-5">
                      <div className="rating mb-4">
                        {[...Array(testimonio.rating)].map((_, i) => (
                          <FaStar key={i} className="text-warning fs-4 mx-1" />
                        ))}
                      </div>
                      <blockquote className="testimonial-text fs-5 mb-4 fst-italic text-muted">
                        "{testimonio.text}"
                      </blockquote>
                      <div className="testimonial-author">
                        <strong className="fs-5 text-dark">{testimonio.author}</strong>
                        <div className="text-danger small fw-bold mt-1">
                          <FaCheck className="me-1" /> {testimonio.project}
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
              
              <div className="text-center mt-2">
                <Button 
                  variant="outline-dark" 
                  size="lg"
                  href="https://g.page/r/CYU8aD9k5psMEAE/review" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fw-bold px-4 rounded-pill"
                >
                  <FaGoogle className="me-2 text-danger" /> Dejar Mi Reseña
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* SUPPLIERS SECTION */}
      <section className="hormigon-suppliers-section py-5 bg-light border-top">
        <Container>
          <h2 className="text-center mb-5 text-dark">
            EMPRESAS QUE <span className="text-red">NOS ELIGEN</span>
          </h2>
          <div className="suppliers-carousel-container">
            <Carousel indicators={false} interval={3000} pause="hover" touch={true} wrap={true} variant="dark">
              {Array.from({ length: Math.ceil(suppliers.length / 6) }).map((_, slideIndex) => (
                <Carousel.Item key={slideIndex}>
                  <Row className="justify-content-center g-4">
                    {suppliers.slice(slideIndex * 6, (slideIndex + 1) * 6).map((supplier, idx) => (
                      <Col key={`${slideIndex}-${idx}`} md={2} sm={4} xs={6} className="text-center">
                        <div className="supplier-card bg-white p-3 rounded-3 shadow-sm border border-light h-100 d-flex align-items-center justify-content-center">
                          <img 
                            src={supplier.src} 
                            alt={supplier.alt} 
                            className="supplier-logo img-fluid opacity-75 hover-opacity-100 transition-all" 
                            style={{maxHeight: '60px', objectFit: 'contain'}}
                            loading="lazy" 
                          />
                        </div>
                      </Col>
                    ))}
                  </Row>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </Container>
      </section>

      {/* ABOUT SECTION */}
      <section className="hormigon-about-section py-5">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="pe-md-5">
              <h2 className="hormigon-section-title mb-4 text-dark">
                <span className="hormigon-text-red">40 AÑOS</span> LIDERANDO EL MERCADO
              </h2>
              <p className="hormigon-section-subtitle mb-4 text-dark">
                Desde 1978, Darom SA ha sido sinónimo de calidad y confiabilidad en el sector de la construcción.
              </p>
              <div className="hormigon-features-grid mb-4">
                {['Hormigón elaborado bajo normas CIRSOC 200/2024', 'Tecnología de última generación', 'Equipo técnico altamente capacitado', 'Soporte integral pre y post venta'].map((feature, idx) => (
                  <div key={idx} className="feature-item">
                    <FaCheckCircle className="hormigon-check-icon text-red" />
                    <span className="text-dark">{feature}</span>
                  </div>
                ))}
              </div>
              <ContactButton text="HABLAR CON UN EXPERTO" center={true} />
            </Col>
            <Col md={6}>
              <div className="rounded-4 overflow-hidden shadow-lg mt-4 mt-md-0">
                <img src="/IMG_3139.jpg" alt="Historia Darom SA" className="img-fluid w-100" style={{objectFit: 'cover'}} loading="lazy" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

    </Container>
  );
}

export default Hormigon;